import { render, staticRenderFns } from "./PersonalizationValues.vue?vue&type=template&id=69700f82&scoped=true"
import script from "./PersonalizationValues.vue?vue&type=script&lang=js"
export * from "./PersonalizationValues.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationValues.vue?vue&type=style&index=0&id=69700f82&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69700f82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69700f82')) {
      api.createRecord('69700f82', component.options)
    } else {
      api.reload('69700f82', component.options)
    }
    module.hot.accept("./PersonalizationValues.vue?vue&type=template&id=69700f82&scoped=true", function () {
      api.rerender('69700f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/personalization/PersonalizationValues.vue"
export default component.exports